module.exports = global["$"] = require("-!/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/expose-loader/index.js?jQuery!./jquery.js");